import {Component, Injector, OnInit} from '@angular/core';
import {BasePropostaComponent} from '../base-proposta';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import * as jwt_decode from 'jwt-decode';
import {AppComponent} from '../../../app.component';
import {CategoriaPlanoService} from '../../../core/services/categoria_plano.service';
import {RdService} from '../../../core/services/rd.service';
import {CupomService} from '../../../core/services/cupom.service';
import {AutenticacaoClienteSiteService} from '../../../core/services/autenticacao_cliente_site.service';
import {CepService} from '../../../core/services/cep.service';
import {PropostaService} from '../../../core/services/proposta.service';
import {Meta, Title} from '@angular/platform-browser';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.sass']
})
export class LoginComponent extends BasePropostaComponent implements OnInit {
    cliente: any;
    form: FormGroup;
    onSubmit = false;

    constructor(
        protected injector: Injector,
        public cupomService: CupomService,
        public propostaService: PropostaService,
        public router: Router,
        public formBuilder: FormBuilder,
        public cepService: CepService,
        public autenticacaoService: AutenticacaoClienteSiteService,
        public toast: ToastrService,
        public categoriaPlanoService: CategoriaPlanoService,
        public rdService: RdService,
        public appComponent: AppComponent,
        public titleService: Title,
        public meta: Meta,
        public deviceService: DeviceDetectorService
        ) {
        super(injector);

        this.cliente = this.getCliente();
        if (this.cliente === null) {
            this.cliente = this.getClienteCpf();
        }
        this.form = formBuilder.group({
            username: new FormControl(this.cliente.email, [Validators.required, Validators.email]),
            password: new FormControl(null, [Validators.required]),
        });
    }

    async ngOnInit() {
        await this.inOnInit();
    }

    getErrorMessage(field: string) {
        if (!this.onSubmit) {
            return '';
        }

        const input = this.form.get(field);
        return input.hasError('required') ? 'Campo obrigatório' :
            input.hasError('cpf') ? 'CPF inválido' :
                input.hasError('invalidDate') ? 'Insira uma data válida.' :
                    input.hasError('notSame') ? 'E-mail não confere.' :
                        input.hasError('email') ? 'E-mail inválido.' :
                            '';
    }

    async submit() {
        this.onSubmit = true;

        if (this.form.valid) {
            const result = await this.autenticacaoService.authenticate(this.form.value);

            if (result.status === 200) {
                this.armazenarTokenUsuario(result.data.id_token);
                const proposta = jwt_decode(result.data.id_token);

                const propostaSiteResult = await this.propostaService.buscarProposta(proposta.id);
                propostaSiteResult.data.itensProposta = propostaSiteResult.data.listaTitulos;
                this.addPropostaParaStorage(propostaSiteResult.data);

                const response = await this.propostaService.cadastroDadosCarrinho(this.queryCarrinho());

                if (response.status === 200) {
                    if (this.cliente.exCliente && !this.cliente.temPropostaAberta) {
                        await this.rdService.carrinhoLogin(this.cliente.email);
                        await this.router.navigate(['dados-pessoais']);
                    } else if (this.cliente.exCliente && this.cliente.temPropostaAberta) {
                        await this.router.navigate(['proposta-analise']);
                    } else {
                        await this.router.navigate(['confirmacao-compra']);
                    }
                } else {
                    this.toast.error('Carrinho já cadastrado');
                }
            } else if (result.status === 400 || result.status === 409) {
                this.toast.error(result.error.description);
            }
        }
    }
}
